import { render } from "./TermsOfService.html?vue&type=template&id=70e7bd21&scoped=true&external"
import script from "./TermsOfService.js?vue&type=script&lang=javascript&external"
export * from "./TermsOfService.js?vue&type=script&lang=javascript&external"

import "./TermsOfService.scss?vue&type=style&index=0&id=70e7bd21&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e7bd21"]])

export default __exports__